import ChangeLang from "./ChangeLang";
import './ChangeLang.css';

export default ChangeLang;